import { useEffect, useState, useCallback } from "react";

import { getCaseId, getClientId } from "../../../../Utils/helper";
import api from "../../../../api/api";

export const useGetHistoryData = () => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const clientId = getClientId();
  const caseId = getCaseId();

  const fetchEmploymentHistory = useCallback(async () => {
    // Don't fetch if required params are missing
    if (!clientId || !caseId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await api.get(`/api/employment/history/${caseId}/${clientId}/`);

      if (response.status === 200) {
        setHistoryData(response.data.data || []);
      } else {
        const errorMessage = response.data.message || "Failed to fetch employment history data";
        setError(errorMessage);
        console.error("Failed to fetch employment history data:", errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch employment history data";
      setError(errorMessage);
      console.error("Error fetching employment history data:", error);
      setHistoryData([]); // Reset to empty array on error
    } finally {
      setLoading(false);
    }
  }, [clientId, caseId, origin]);

  useEffect(() => {
    fetchEmploymentHistory();
  }, [fetchEmploymentHistory]);

  const refetch = useCallback(() => {
    fetchEmploymentHistory();
  }, [fetchEmploymentHistory]);

  return {
    historyData,
    loading,
    error,
    refetch,
  };
};
